import { createSlice } from '@reduxjs/toolkit';
import { WebCollaborationState } from './web-collaboration-types';
import { addAllBasicExtraReducers } from '../../../utils/action-builder-utils';
import { createRoom, getWBStatus, postWBAnswer, postWBCandidate, postWBOffer } from './web-collaboration-thunks';



const initialState: WebCollaborationState = {
  roomId: null,
  exit: false,
  roomIdRequestStatus: 'idle',
  offerRequestStatus: 'idle',
  answerRequestStatus: 'idle',
  statusRequestStatus: 'idle',
  candidateRequestStatus: 'idle',
};

const webCollaborationSlice = createSlice({
  name: 'features/webCollaboration',
  initialState,
  reducers: {
    reset: () => initialState,
    exit: (state) => {
      state.exit = true;
      state.roomId = null;
      state.screenSharingActive = false;
    },
    setIsProspect: (state, action) => {
      state.isProspect = action.payload;
    },
    setRoomId: (state, action) => {
      state.roomId = action.payload;
    },
    setScreenSharingActive: (state, action) => {
      state.screenSharingActive = action.payload;
    },
    resetOffer: (state) => {
      state.offer = null;
      state.answer = null;
      state.candidate = null;
    }
  },
  extraReducers: (builder) => {
    addAllBasicExtraReducers(builder, createRoom, 'roomId');
    addAllBasicExtraReducers(builder, postWBOffer, 'offer');
    addAllBasicExtraReducers(builder, postWBAnswer, 'answer');
    addAllBasicExtraReducers(builder, postWBCandidate, 'candidate');
    builder.addCase(getWBStatus.pending, (state) => {
      state.statusRequestStatus = 'loading';
    });
    builder.addCase(getWBStatus.fulfilled, (state, action) => {
      state.statusRequestStatus = 'succeeded';
      state.status = action.payload.roomStatus;
      state.roomId = action.payload.roomId;
      state.answer = action.payload.answer;
      state.offer = action.payload.offer;
      state.candidate = action.payload.iceCandidate;
    });
    builder.addCase(getWBStatus.rejected, (state) => {
      state.statusError = 'GENERIC_ERROR';
      state.statusRequestStatus = 'failed';
    });
  },
});

export const webCollaborationSliceActions = webCollaborationSlice.actions;

export default webCollaborationSlice.reducer;
